import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';
dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);
import { DEPRECATED_TIMEZONES, INVALID_DATE } from '../contants';
export var formatDate = function (utcISODate, timezoneName, formatPattern) {
    if (formatPattern === void 0) { formatPattern = 'YYYY-MM-DD HH:mm'; }
    try {
        var timezone = DEPRECATED_TIMEZONES[timezoneName] || timezoneName;
        return dayjs.utc(utcISODate).tz(timezone).format(formatPattern);
    }
    catch (err) {
        return INVALID_DATE;
    }
};
export default formatDate;
